export const generateMapleImageUrlWithMotions = ({
  url,
  action,
  emotion,
}: {
  url: string;
  action: string;
  emotion: string;
}) => {
  const originalUrl = urlWithoutQuery(url);
  const urlObj = new URL(originalUrl);

  if (action) {
    urlObj.searchParams.set('action', action);
  }
  if (emotion) {
    urlObj.searchParams.set('emotion', emotion);
  }

  return urlObj.toString();
};

export const urlWithoutQuery = (url: string) => {
  const parsedUrl = new URL(url);
  return `${parsedUrl.origin}${parsedUrl.pathname}`;
};
